import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";

import { connect } from "react-redux";
import axios from "axios";
import PropTypes from "prop-types";
import { Link } from "react-router";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import * as actions from "../../store/actions";

import { apiProviderSupportsFeature } from "../../variables/app";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { Tooltip } from "@mui/material";

// material-ui icons
import {
  Add,
  Alarm,
  ArrowDownward,
  AssignmentLate,
  AvTimer,
  Delete,
  Edit,
  FreeBreakfast,
  Layers,
  Refresh,
} from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button";

//Modals
import Copy from "./Modals/Copy";
import Pause from "./Modals/Pause";

import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";

//Filters
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";

import MassEdit from "./Modals/MassEdit";
import CategoryFilter from "../../components/Filters/CategoryFilter";
import TextFilter from "../../components/Filters/TextFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import VestigingFilterV2, { getVestigingFilterStateV2 } from "../../components/VestigingFilter/VestigingFilter";
import { toast } from "react-toastify";

class OldIndex extends React.Component {
  state = {
    menukaarten: [],
    selectedIds: [],
    copyModal: false,
    pauseModal: false,
    showDeleteAlert: false,
    showOptimizeImages: false,
    massEditModal: false,
  };

  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.refreshData();
  };

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentRequest != undefined) {
      this.currentRequest.cancel();
    }
  }

  forceRetryTranslations = () => {
    const confirmed = window.confirm(
      getTranslation(
        "producten.retry.confirm",
        "Are you sure you want to force retry all product translations? This will overwrite existing translations!"
      )
    );

    if (confirmed) {
      axios
        .post("core/producten/forceRetryTranslations", {
          sales_area_id: this.props.vestiging_id,
        })
        .then((response) => {
          if (response.data) {
            toast.success(getTranslation("producten.resize.queued", "Translations queued, this may take a while"));
          } else {
            toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
          }
        })
        .catch((err) => {
          toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
        });
    }
  };

  toggleModal(modal) {
    const newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDupliceerAction = (row) => {
    this.setState({
      selectedIds: [row[0]],
      copyModal: true,
    });
  };

  handleMultieSelect = (ids) => {
    this.setState({ selectedIds: ids });
  };

  handleMultiDelete = () => {
    const data = {
      ids: this.state.selectedIds,
    };

    axios.post("core/producten/multipledelete", data).then((response) => {
      const aantal = response.data.data.deleted;
      this.toggleModal("showDeleteAlert");
      toast.warn(aantal + " items verwijderd");
      this.refreshJamezzTable();
    });
  };

  handleOptimizeImages = () => {
    const data = {
      ids: this.state.selectedIds,
    };
    this.toggleModal("showOptimizeImages");
    axios.post("core/producten/optimizeimages", data).then((response) => {
      const aantal = response.data.data.optimized;
      toast.success(aantal + " items queued for optimalisation");
      this.refreshJamezzTable();
    });
  };

  jsonEmpty = (data) => {
    try {
      const resData = JSON.parse(data);
      switch (typeof resData) {
        case "object":
          return !Object.keys(resData).length;
        case "array":
          return !resData.length;
      }
    } catch (e) {}
    return true;
  };

  information = (data) => {
    const icons = [];
    if (data.timeTable !== null && data.timeTable !== "" && !this.jsonEmpty(data.timeTable)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Heeft een tijdschema"} tKey={"tooltip.hasTimeTable"} />}
        >
          <AvTimer
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    if (data.hideArrangement !== null && data.hideArrangement !== "" && !this.jsonEmpty(data.hideArrangement)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Onderdeel van een arrangement"} tKey={"tooltip.belongsToArrangment"} />}
        >
          <AssignmentLate
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    if (data.showArrangement !== null && data.showArrangement !== "" && !this.jsonEmpty(data.showArrangement)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Onderdeel van een arrangement"} tKey={"tooltip.belongsToArrangment"} />}
        >
          <AssignmentLate
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    return <div>{icons}</div>;
  };

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  hideOptimizeImagesAlert = () => {
    this.setState({ showOptimizeImages: false });
  };

  render() {
    const { classes } = this.props;

    if (
      // this.props.filters?.vestiging_id &&
      this.props.filters?.["producten:name"] &&
      this.props.filters?.vestiging_id?.value == null &&
      this.props.filters?.["vestiging.venue_id"]?.value == null
    ) {
      this.props.setFilter("producten:name", null);
    }

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Producten overzicht"} tKey={"producten.pagetitle"} />}
        />
        <GridContainer>
          <GridItem>
            {this.props.vestiging_id ? (
              <div style={{ display: "flex", flexWrap: "wrap", padding: "8px 0px 8px 0px" }}>
                <AuthenticationWrapper permissionKey={"producten.create"}>
                  <Link to={"./create"}>
                    <Button className={classes.marginRight} color={"success"}>
                      <Add className={classes.icons} />
                      <TranslationWrapper tDefault={"Nieuw product"} tKey={"producten.nieuw.item"} />
                    </Button>
                  </Link>
                  <Link to={"./import"}>
                    <Button className={classes.marginRight} color={"success"}>
                      <ArrowDownward className={classes.icons} />
                      <TranslationWrapper tDefault={"Importeer"} tKey={"producten.importeer.item"} />
                    </Button>
                  </Link>
                </AuthenticationWrapper>

                <AuthenticationWrapper permissionKey={"producten.translate.force"}>
                  <Button className={classes.marginRight} color={"danger"} onClick={this.forceRetryTranslations}>
                    <Refresh className={classes.icons} />
                    <TranslationWrapper tDefault={"Force retry translations"} tKey={"producten.translate.force"} />
                  </Button>
                </AuthenticationWrapper>
              </div>
            ) : null}

            {this.state.selectedIds.length > 0 && this.jamezzTable.current.state.showArchive === false ? (
              <>
                <Button className={classes.marginRight} color={"success"} onClick={() => this.toggleModal("copyModal")}>
                  <Layers className={classes.icons} />
                  <TranslationWrapper tDefault={"Dupliceer producten"} tKey={"producten.dupliceer.item"} />
                </Button>
                <Button
                  className={classes.marginRight}
                  color={"success"}
                  onClick={() => this.toggleModal("massEditModal")}
                >
                  <Edit className={classes.icons} />
                  <TranslationWrapper tDefault={"aanpassen"} tKey={"producten.massEdit"} />
                </Button>
                <Button
                  className={classes.marginRight}
                  color={"success"}
                  onClick={() => this.toggleModal("pauseModal")}
                >
                  <Alarm className={classes.icons} />
                  <TranslationWrapper tDefault={"Pause products"} tKey={"producten.dupliceer.pause"} />
                </Button>
                <br />
                <Button
                  className={classes.marginRight}
                  color={"danger"}
                  onClick={() => this.toggleModal("showOptimizeImages")}
                >
                  <Refresh className={classes.icons} />
                  <TranslationWrapper tDefault={"Optimize images"} tKey={"producten.retry.image.optimize"} />
                </Button>
                <AuthenticationWrapper permissionKey={"producten.delete"}>
                  <Button
                    className={classes.marginRight}
                    color={"danger"}
                    onClick={() => this.toggleModal("showDeleteAlert")}
                  >
                    <Delete className={classes.icons} />
                    <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />
                  </Button>
                </AuthenticationWrapper>
              </>
            ) : null}
          </GridItem>
        </GridContainer>

        <GridContainer>
          <VestigingFilterV2 useMenukaartReferences={true} />
          <GridItem sm={4} xs={12}>
            <CategoryFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <TextFilter
              disabled={Object.keys(this.props.filters).length === 0}
              extraFilterKeyValuePairs={{
                vestiging_id: this.props.filters?.vestiging_id?.value,
                venue_id: this.props.filters?.["vestiging.venue_id"]?.value,
              }}
              field={["naam", "apiId1", "id"]}
              fieldKey={"producten:name"}
              operator={"like"}
              placeholder={getTranslation("producten.filter.product", "Filter op product")}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Layers,
                  tooltip: <TranslationWrapper tDefault={"Dupliceer"} tKey={"producten.table.tooltip.dupliceer"} />,
                  action: this.handleDupliceerAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "externalId", editable: false },
                { dbfield: "vestiging.naam", editable: false },
                { dbfield: "media_urls.imgid", editable: true, inputtype: "Image" },
                { dbfield: "naam", editable: true, inputtype: "Input" },
                {
                  dbfield: "menukaart.id",
                  customData: (row) => {
                    return row.menukaart.map((kaart) => {
                      return {
                        value: kaart.id,
                        label: kaart.naam,
                      };
                    });
                  },
                  getDataMapping: (rowData) => {
                    const mapping = {
                      dbfield: "menukaart.id",
                      inputtype: "Async",
                      editable: true,
                      async: {
                        url: `core/kaarten/search?fields=id as value,naam as label&per_page=1000&sort_field=naam&sort_dir=asc&vestiging_id=${rowData.vestiging_id}`,
                        searchField: "naam",
                      },
                      nullValue: 0,
                    };

                    if (rowData["vestiging.appTarget"] === "appv5.js") {
                      // show multi selector
                      mapping.multiple = true;
                      mapping.value = rowData["menukaart.id"];
                    } else {
                      if (rowData["menukaart.id"].length > 1) {
                        mapping.titleOnHover = {
                          tKey: "product.jamezzTable.multiMenukaartFeature.onHoverTitle",
                          tDefault:
                            "Multiple menus will soon be available in Jamezz V5! In older versions multiple menus won't be supported!",
                        };

                        // show multi selector
                        mapping.multiple = true;
                        mapping.value = rowData["menukaart.id"];
                      } else if (rowData["menukaart.id"]?.[0]?.value) {
                        // show single selector
                        mapping.value = {
                          label: rowData["menukaart.id"][0].label,
                          value: rowData["menukaart.id"][0].value,
                        };
                      }
                    }

                    return mapping;
                  },
                },
                {
                  dbfield: "menukaart.naam",
                  hide: true,
                },
                {
                  // Duplication is necessary. Don't remove
                  dbfield: "prijs",
                  inputtype: "Valuta",
                  customData: function (responseData) {
                    return {
                      value: responseData.prijs,
                      currency: responseData.valuta ?? "EUR",
                    };
                  },
                  getDataMapping: (rowData) => {
                    return {
                      editable: apiProviderSupportsFeature(rowData["vestiging.apiProvider"], "editProductPrice"),
                      dbfield: "prijs",
                      inputtype: "Valuta",
                    };
                  },
                },
                {
                  dbfield: "is_actief",
                  getDataMapping: (rowData) => {
                    return {
                      inputtype: "Switch",
                      editable: apiProviderSupportsFeature(rowData["vestiging.apiProvider"], "editProductActive"),
                      dbfield: "is_actief",
                    };
                  },
                },
                { dbfield: "blocked", editable: true, inputtype: "Switch" },
                {
                  dbfield: "stock",
                  editable: true,
                  inputtype: "Number",
                  inputProps: { type: "number", decimalen: 0 },
                },
                {
                  dbfield: "sortkey",
                  editable: true,
                  inputtype: "Number",
                  inputProps: { type: "number", decimalen: 0 },
                },
                { customData: this.information },
                { dbfield: "vestiging_id", hide: true },
                { dbfield: "vestiging.apiProvider", hide: true },
                { dbfield: "vestiging.appTarget", hide: true },
                { dbfield: "is_archivable", hide: true },
              ]}
              dbfields={[
                "id",
                "apiId1",
                "apiId2",
                "untillid",
                "mrwid",
                "mplusPn",
                "vectronId",
                "naam",
                "vestiging_id",
                "vestiging.id",
                "vestiging.naam",
                "vestiging.valuta",
                "vestiging.priceMode",
                "vestiging.apiProvider",
                "vestiging.appTarget",
                "imgid",
                "prijs",
                "prijsEatIn",
                "prijsDelivery",
                "prijsTakeaway",
                "is_actief",
                "blocked",
                "stock",
                "timeTable",
                "showArrangement",
                "hideArrangement",
                "sortkey",
                "menukaart.id",
                "menukaart.naam",
                "is_archivable",
                "media.*",
              ]}
              delete={"producten.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"producten/:id/edit"}
              fetchUrl={"core/producten"}
              filters={this.props.filters}
              headerIcon={<FreeBreakfast />}
              headers={[
                {
                  label: getTranslation("producten.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                  width: "4%",
                },
                {
                  label: getTranslation("producten.table.apiId", "# API"),
                  sortable: false,
                  width: "4%",
                },
                {
                  label: getTranslation("producten.table.vestigingnaam", "Salesarea"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                  width: "8%",
                },
                {
                  label: getTranslation("producten.table.img", "Img"),
                  sortable: false,
                  width: "4%",
                },
                {
                  label: getTranslation("producten.table.naam", "Naam"),
                  sortable: true,
                  sortKey: "naam",
                  width: "20%",
                },
                {
                  label: getTranslation("producten.table.menukaart", "Menukaart"),
                  sortable: false,
                  width: "20%",
                },
                {
                  label: getTranslation("producten.table.prijs", "Prijs"),
                  width: "7%",
                  sortable: true,
                  sortKey: "prijs",
                },
                {
                  label: getTranslation("producten.table.actief", "Actief"),
                  width: "4%",
                  sortable: true,
                  sortKey: "is_actief",
                },
                {
                  label: getTranslation("producten.table.blocked", "blocked"),
                  width: "4%",
                  sortable: true,
                  sortKey: "blocked",
                },
                {
                  label: getTranslation("producten.table.stock", "voorraad"),
                  width: "3%",
                  sortable: true,
                  sortKey: "stock",
                },
                {
                  label: getTranslation("global.table.sortkey", "sortkey"),
                  width: "3%",
                  sortable: true,
                  sortKey: "sortKey",
                },
                {
                  label: getTranslation("global.table.empty", ""),
                  width: "3%",
                  sortable: false,
                },
              ]}
              inputValues={{
                menukaarten: this.state.menukaarten,
              }}
              legacy={false}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"producten"}
              ref={this.jamezzTable}
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Producten"} tKey={"producten.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        <Copy
          open={this.state.copyModal}
          productIds={this.state.selectedIds}
          refreshTable={() => this.refreshJamezzTable()}
          toggle={() => this.toggleModal("copyModal")}
        />

        <Pause
          open={this.state.pauseModal}
          productIds={this.state.selectedIds}
          refreshTable={() => this.refreshJamezzTable()}
          salesAreaId={this.props.filters?.vestiging_id?.value}
          toggle={() => this.toggleModal("pauseModal")}
        />

        {this.state.massEditModal ? (
          <MassEdit
            open={this.state.massEditModal}
            productIds={this.state.selectedIds}
            refreshTable={() => this.refreshJamezzTable()}
            toggle={() => this.toggleModal("massEditModal")}
          />
        ) : null}

        {this.state.showDeleteAlert ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.hideDeleteAlert}
            onConfirm={this.handleMultiDelete}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={<TranslationWrapper tDefault={"Weet je het zeker?"} tKey={"global.jamezztable.confirm"} />}
            warning
          >
            {this.state.selectedIds.length} item(s)
          </SweetAlert>
        ) : null}

        {this.state.showOptimizeImages ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Cancel"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Proceed"} tKey={"global.buttons.proceed"} />}
            onCancel={this.hideOptimizeImagesAlert}
            onConfirm={this.handleOptimizeImages}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={<TranslationWrapper tDefault={"Important notice!"} tKey={"global.jamezztable.importantNotice"} />}
            warning
          >
            <TranslationWrapper
              tDefault={
                "Notice! There are costs associated with the automatic optimization of images. The cost for optimizing and " +
                "automatically cropping images is € 0.30 per image. If you proceed now these costs will be charged " +
                "automatically."
              }
              tKey={"global.jamezztable.optimizeImages"}
            />
          </SweetAlert>
        ) : null}
      </div>
    );
  }
}

OldIndex.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  const filters = getVestigingFilterStateV2(state, true);

  if (state.filtersV2["menukaart.id"]) {
    filters["menukaart.id"] = state.filtersV2["menukaart.id"];
  }
  if (state.filtersV2["producten:name"]) {
    filters["producten:name"] = state.filtersV2["producten:name"];
  }

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OldIndex, productenStyle));
